import React, { useEffect, useRef, createElement } from 'react';
const BOOKING_URL = 'https://api.leadconnectorhq.com/widget/booking/1g6eHWSDJJGq9FIQ5WxM';
const EMBED_SCRIPT = 'https://api.leadconnectorhq.com/js/form_embed.js';
export function BookingEmbed() {
  const scriptLoaded = useRef(false);
  useEffect(() => {
    if (scriptLoaded.current) return;
    scriptLoaded.current = true;
    // Load the LeadConnector embed script
    const script = document.createElement('script');
    script.src = EMBED_SCRIPT;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup on unmount
      try {
        document.body.removeChild(script);
      } catch {
        // Script may already be removed
      }
    };
  }, []);
  return <div className="w-full min-h-[400px]" data-id="element-75">
      <div className="text-center mb-4" data-id="element-76">
        <h3 className="text-2xl font-light text-brand-dark mb-1" data-id="element-77">
          Schedule your visit
        </h3>
        <p className="text-brand-muted text-sm font-light" data-id="element-78">
          Pick a date and time that works for you.
        </p>
      </div>
      <iframe src={BOOKING_URL} style={{
      width: '100%',
      border: 'none',
      overflow: 'hidden',
      minHeight: '500px'
    }} scrolling="no" id="1g6eHWSDJJGq9FIQ5WxM_1777384141373" title="Book an appointment" data-id="element-79" />
    </div>;
}